import { useEffect } from "react";

let activeCount = 0;

// Radix only aria-hides the page behind a modal; browser find-in-page still searches it. `inert` removes it from find.
export const useInertAppRoot = (active: boolean) => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (!active || !root) return;

    activeCount += 1;
    root.setAttribute("inert", "");

    return () => {
      activeCount -= 1;
      if (activeCount === 0) root.removeAttribute("inert");
    };
  }, [active]);
};
